const defaultApiUrl = 'https://api.office.teknologikartu.com/api/v1/app_builder/';
const defaultWebSocketUrl = 'wss://api.office.teknologikartu.com/api/v1/app_builder/';

const withTrailingSlash = (url) => (url.endsWith('/') ? url : `${url}/`);

// Create React App inlines these at build time. A production build prefers the *_PROD value and a
// dev server the *_DEV value; the other is the fallback so a build that defines only one still works.
// The page's hostname is never consulted, so a staging build cannot silently talk to production.
const pick = (prod, dev, fallback) => withTrailingSlash((process.env.NODE_ENV === 'production' ? prod || dev : dev || prod) || fallback);

const Config = {
    ApiBaseUrl: pick(process.env.REACT_APP_APP_BUILDER_BASE_URL_PROD, process.env.REACT_APP_APP_BUILDER_BASE_URL_DEV, defaultApiUrl),
    WebSocketUrl: pick(process.env.REACT_APP_APP_BUILDER_WS_URL_PROD, process.env.REACT_APP_APP_BUILDER_WS_URL_DEV, defaultWebSocketUrl),
    CrmLoginUrl: process.env.REACT_APP_CRM_LOGIN_URL || "https://api.stg.teknologikartu.com/crmv2/main_auth/auth/login",
};

export default Config;
